import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { cn } from "@/lib/utils";
import { Home } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Retour à l'accueil du back-office, identique sur tous les écrans (dashboards,
 * fiches, CMS). Même gabarit que les boutons du Header (Notes, Exporter… :
 * icône h-5 w-5 au-dessus du libellé), mais en bleu IZ (#005d8d) et à la
 * typo des boutons Retour/Précédent/Suivant, bulle d'aide noire. Une seule clé de
 * traduction sert au libellé, à la bulle et à l'`aria-label`.
 */
export const HomeButton = ({ className }: { className?: string }) => {
  const vt = useVisibleT();
  const label = vt("bo.nav.home", "Accueil");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          asChild
          variant="outline"
          className={cn(
            "h-auto shrink-0 flex-col gap-0 border-0 px-3 pt-2.5 pb-px font-['Raleway'] text-sm font-semibold text-[#005d8d] shadow-none hover:text-[#005d8d]",
            className,
          )}
        >
          <Link to="/accueil">
            <Home className="h-5 w-5" aria-hidden />
            {label}
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom" variant="action" className="px-3">
        <span className="text-white text-sm font-medium">{label}</span>
      </TooltipContent>
    </Tooltip>
  );
};
